import {Props_SnippetLinkCard} from "./LinkCard.props";

const SnippetLinkCard = (props: Props_SnippetLinkCard) => {
    const {heading, text, linkProps, background} = props;
    const classHeadingVisibility = heading.visibility?.value === false ? 'accessible-heading' : '';


    return (
        <div className='link-card__wrapper'>
            <section className={`link-card ${background?.colour?.value ? `link-card--${background.colour.value}` : 'link-card--background-one'}`}>
                    <div className='link-card__container'>
                    {heading?.content?.value &&
                        <h2 className={`link-card__heading ${classHeadingVisibility}`}>
                            {heading.content.value}
                        </h2>
                    }
                    {text?.content?.value &&
                        <p className='link-card__text'>
                            {text.content.value}
                        </p>
                    }
                    {linkProps?.linkHref?.value &&
                        <a 
                            href={linkProps.linkHref.value} 
                            className='link-card__link' 
                            target={linkProps.linkTarget?.value ? '_blank' : '_self'}
                            rel={linkProps.linkTarget?.value ? 'noopener noreferrer' : undefined}
                        >
                            {linkProps.linkText?.value || 'Learn more'}
                        </a>
                    }
                </div>
            </section>
        </div>
    )
}
export default SnippetLinkCard